// extracted by mini-css-extract-plugin
export default {"waitingMessage":"waitingMessage_waitingMessage__HUw0m"};